import { Link } from 'react-router';
import { formatDate, formatDateTime } from '../../../shared/format.ts';
import { Help } from '../../components/ui.tsx';
import { useUserContext } from './UserLayout.tsx';

export function UserViewPage() {
  const { user, me, isSelf } = useUserContext();
  const base = `/users/${encodeURIComponent(user.id)}`;

  if (!me) {
    return (
      <div className="card page-narrow">
        <p>
          <span className="call">{user.id}</span> – {user.name}
        </p>
        <p className="muted">
          <Link to="/login">Kirjaudu sisään</Link> nähdäksesi käyttäjän tiedot ja yhteydet.
        </p>
      </div>
    );
  }

  const rows: Array<[string, React.ReactNode]> = [
    ['Kutsu', <span className="call">{user.id}</span>],
    ['Nimi', user.name],
    ['Sähköposti', user.email ? <a href={`mailto:${user.email}`}>{user.email}</a> : '–'],
    ['Lisenssi saatu', formatDate(user.licenceDate) || '–'],
    ['Luokka', user.userClass],
    ['Sukupuoli', user.genre],
    ['Rooli', user.roleId === 1 ? 'Ylläpitäjä' : 'Käyttäjä'],
  ];
  if (user.address1 !== undefined) {
    rows.push(['Osoite', [user.address1, user.address2].filter(Boolean).join(', ') || '–']);
    rows.push(['Postinumero ja kaupunki', [user.postcode, user.city].filter(Boolean).join(' ') || '–']);
  } else if (user.city) rows.push(['Kaupunki', user.city]);

  return (
    <div className="stack">
      <div className="stats">
        <div className="stat">
          <div className="label">QSO:t</div>
          <div className="value">{(user.qsoCount ?? 0).toLocaleString('fi-FI')}</div>
        </div>
        <div className="stat">
          <div className="label">Maita logissa</div>
          <div className="value">{user.countryCount ?? 0}</div>
        </div>
        <div className="stat">
          <div className="label">Logi päivitetty</div>
          <div className="value" style={{ fontSize: '1rem', paddingTop: 10 }}>
            {formatDateTime(user.qsoUpdated) || '–'}
          </div>
        </div>
      </div>

      <div className="card page-narrow">
        <div className="card-title">
          <h2>{isSelf ? 'Omat tiedot' : 'Käyttäjän tiedot'}</h2>
          <Help name="OmatTiedot" />
        </div>
        <table className="table compact">
          <tbody>
            {rows.map(([k, v]) => (
              <tr key={k}>
                <td className="muted" style={{ width: 220 }}>
                  {k}
                </td>
                <td>{v}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!user.active && <div className="alert alert-warn" style={{ marginTop: 14 }}>Tunnus ei ole aktiivinen.</div>}
        <div className="form-actions" style={{ marginTop: 16 }}>
          <Link className="btn" to={`${base}/qsos`}>
            Näytä QSO:t
          </Link>
          <Link className="btn" to={`${base}/matrix`}>
            DXCC-taulukko
          </Link>
          {isSelf && (
            <Link className="btn btn-primary" to="/import/adif">
              Lataa ADIF-logi
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
